<template>
  <b-container fluid>
    <b-alert v-model="showErrorStatusChange" placement="top" duration="3000" variant="danger" dismissible>
      <strong>{{ $t('LNG_ERROR', this.lang) }}</strong>
      <p>{{ $t('LNG_TEACHER_STATUS_WAS_NOT_CHANGED', this.lang) }}</p>
    </b-alert>
    
    <b-row>
      <b-col cols="12">
        <h3>{{ $t('LNG_TEACHER_MANAGEMENT_TITLE', this.lang) }}</h3>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col cols="2" class="mb-3">
      <b-button type="button" class="btn btn-warning btn-block" v-on:click.prevent="importTeacher()">{{ $t('LNG_IMPORT_TEACHER', this.lang) }}</b-button>
      </b-col>
    </b-row>
     
    <b-row>
      <b-col cols="12">
        <v-client-table ref="teachersTable" :data="teachersData" :columns="teachersColumns" :options="teachersOptions">
          <div slot="disabled" slot-scope="props" class="fa" v-bind:class="{'fa-minus-circle': props.row.disabled === '1', 'fa-check-circle': props.row.disabled === '0'}" v-on:click="changeStatus(props.row.id)" style="cursor: pointer;"></div>
          <div slot="editTeacher" slot-scope="props" class="fa fa-edit" v-on:click="teacherRowClick(props)" style="cursor: pointer;"></div>
       </v-client-table>
      </b-col>
    </b-row>
     
     <b-modal v-model="teacherEditionModal" :title="addTeacherTitle" effect="fade" @shown="setModalInputFocus">
         <div class="alert alert-danger" role="alert" v-if="showTeacherUpdateError">
            {{ this.updateTeacherErrorMessage }}
         </div>
         <b-form @submit="createUpdateNewTeacher">
            <b-form-input ref="name" v-model="name" type="text" required :placeholder="$t('LNG_NAME_TEACHER', this.lang)" class="mb-3"/>
            <b-form-input v-model="firstname" type="text" required :placeholder="$t('LNG_FIRSTNAME', this.lang)" class="mb-3"/>
            <b-form-input v-model="email" type="email" required :placeholder="$t('LNG_EMAIL', this.lang)" class="mb-3"/>
            <b-form-select v-if="this.adminLevel & 4" v-model="selectCenterGroup.value" :options="selectCenterGroup.options" class="mb-3" required></b-form-select>
            <b-button type="button" v-on:click.prevent="exitNewTeacherModal()">{{ $t('LNG_CLOSE', lang) }}</b-button>
            <b-button variant="evaobj" type="submit"><span v-if="this.selectedTeacher === 0"> {{$t('LNG_CREATE', this.lang)}}</span><span v-if="this.selectedTeacher !== 0">{{ $t('LNG_SAVE', this.lang) }}</span></b-button>
         </b-form>
         <div slot="modal-footer" class="modal-footer"></div>
     </b-modal>
     
     <b-modal v-model="fileModalTeachers" effect="fade" size="lg">
       <div class="alert alert-danger" role="alert" v-if="displayTeacherImportAlert">
          {{ $t('LNG_TEACHER_IMPORT_ERRORMESSAGE', this.lang, {importedTeachers: this.importedTeachers}) }} <br/>
          <span style="white-space: pre-wrap;">{{ $t('LNG_TEACHER_IMPORT_ERRORMESSAGE_DETAILS', this.lang,  {errorMessage: this.errorMessage}) }}</span>
       </div>
       <div class="warning alert-warning" role="warning" v-if="displayTeacherImportWarning">
          {{ $t('LNG_TEACHER_IMPORT_WARNINGMESSAGE', this.lang, {importedTeachers: this.importedTeachers}) }} <br/>
          <span style="white-space: pre-wrap;">{{ $t('LNG_TEACHER_IMPORT_WARNINGMESSAGE_DETAILS', this.lang,  {errorMessage: this.errorMessage}) }}</span>
       </div>
       <div class="success alert-success" role="alert-success" v-if="displayTeacherImportSuccess">
          {{ $t('LNG_TEACHER_IMPORT_SUCCESSMESSAGE', this.lang) }} <br/>
          <span style="white-space: pre-wrap;">{{ $t('LNG_TEACHER_IMPORT_SUCCESSMESSAGE_DETAILS', this.lang, {importedTeachers: this.importedTeachers}) }}</span>
       </div>
       <div slot="modal-header" class="modal-header">
          <h4 class="modal-title">
             <b>{{ $t('LNG_SEND_A_FILE', this.lang) }}</b>
          </h4>
       </div>
       <p class="text-left"><b-form-checkbox v-model="teacherFileHasHeader" true-value="1">{{ $t('LNG_TEACHER_SEND_A_FILE_WITH_HEADER', this.lang) }}</b-form-checkbox>
       <br><br>
       {{ $t('LNG_TEACHER_FILE_DESCRIPTION', this.lang) }}       
       </p>
       <b-form @submit="sendFileTeachers">
         <b-form-file accept=".csv" v-model="teachersFile" :state="Boolean(teachersFile)" ref="fileuploadteacher" :placeholder="$t('LNG_FILE', lang)" required />
           <p class="text-left"><small id="fileHelp" class="form-text text-muted">{{ $t('LNG_PLEASE_SELECT_A_FILE', this.lang) }}</small></p>
         
           <b-button type="button" v-on:click.prevent="exitFileModalTeacher()">{{ $t('LNG_CLOSE', lang) }}</b-button>
           <b-button variant="evaobj" type="submit">{{ $t('LNG_SEND', this.lang) }}</b-button>
         </b-form>
         <div slot="modal-footer"></div>
    </b-modal>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'managementTeacher',
  components: {
  },
  data () {
    return {
      selectCenterGroup: {
        options: [],
        value: null
      },
      displayTeacherImportAlert: false,
      fileModalTeachers: false,
      showErrorStatusChange: false,
      newTeacherFormIsValid: false,
      showTeacherUpdateError: false,
      displayTeacherImportWarning: false,
      displayTeacherImportSuccess: false,
      teacherFileHasHeader: false,
      teachersFile: 'import_file',
      updateTeacherErrorMessage: '',
      importedTeachers: 0,
      errorMessage: '',
      name: '',
      firstname: '',
      email: '',
      teacherEditionModal: false,
      selectedTeacher: 0,
      teachersData: [],
      teachersColumns: ['name', 'firstname', 'email', 'lastLogin', 'center', 'disabled', 'editTeacher'],
      teachersOptions: {
        headings: {
          name: this.$t('LNG_NAME_TEACHER', this.lang),
          firstname: this.$t('LNG_FIRSTNAME', this.lang),
          email: this.$t('LNG_EMAIL', this.lang),
          lastLogin: this.$t('LNG_LAST_LOGIN', this.lang),
          center: this.$t('LNG_CENTER_NAME', this.lang),
          disabled: this.$t('LNG_STATUS', this.lang),
          editTeacher: this.$t('LNG_EDIT', this.lang)
        },
        filterByColumn: true,
        perPage: 1000,
        perPageValues: [10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['name', 'firstname', 'email', 'center'],
        sortable: ['name', 'firstname', 'email', 'lastLogin', 'center', 'disabled']
      },
      addTeacherTitle: this.$t('LNG_NEW_TEACHER', this.lang)
    }
  },
  mounted: function () {
    moment.locale('fr-ch')
    this.loadTeachers()
    this.loadCenters()
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ]),
    adminLevel () {
      return this.$store.getters.adminLevel
    }
  },
  methods: {
    setModalInputFocus (event) {
      this.$refs.name.focus()
    },
    back: function () {
      this.$router.push({ path: '/' })
    },
    loadCenters: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadActiveCenters'
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        while (this.selectCenterGroup.options.length > 0) {
          this.selectCenterGroup.options.pop()
        }
        this.selectCenterGroup.options.push({value: null, text: this.$t('LNG_SELECT_CENTER_TEACHER_GROUP_DEFAULT', this.lang)})
        response.data.centers.forEach((e) => {
          this.selectCenterGroup.options.push({text: e.name, value: e.id})
        })
      })
    },
    loadTeachers: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadTeachers'
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.teachersData = response.data.teachers
        this.teachersData.forEach(function (element) {
          if (moment(element.lastLogin).isValid()) {
            element.lastLogin = moment(element.lastLogin).format('DD.MM.YYYY HH:mm:s')
          }
        })
      })
    },
    changeStatus: function (itemId) {
      this.showErrorStatusChange = false
      var newStatus
      this.teachersData.forEach(function (teacher) {
        if (teacher.id === itemId) {
          if (teacher.disabled === '1') {
            newStatus = '0'
          } else {
            newStatus = '1'
          }
        }
      })

      // Change the status in the db
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'setTeacherStatus',
          status: newStatus,
          id: itemId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.teachersData.forEach(function (teacher) {
            if (teacher.id === itemId) {
              teacher.disabled = newStatus
            }
          })
        } else {
          this.showErrorStatusChange = true
        }
      })
    },
    addTeacher: function (itemId) {
      this.addTeacherTitle = this.$t('LNG_NEW_TEACHER', this.lang)
      this.showTeacherUpdateError = false
      this.selectedTeacher = 0
      this.teacherEditionModal = true
    },
    exitNewTeacherModal: function () {
      this.teacherEditionModal = false
      this.showTeacherUpdateError = false
      this.name = ''
      this.firstname = ''
      this.email = ''
      this.selectCenterGroup.value = null
      this.selectedTeacher = 0
    },
    createUpdateNewTeacher: function () {
      this.showTeacherUpdateError = false
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'createUpdateTeacher',
          name: this.name,
          firstname: this.firstname,
          email: this.email,
          center: this.selectCenterGroup.value,
          id: this.selectedTeacher
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.teacherEditionModal = false
          this.name = ''
          this.firstname = ''
          this.email = ''
          this.selectCenterGroup.value = null
          this.selectedTeacher = 0
          this.loadTeachers()
        } else {
          this.updateTeacherErrorMessage = this.$t(response.data.error, this.lang)
          this.showTeacherUpdateError = true
        }
      })
    },
    teacherRowClick: function (data) {
      this.addTeacherTitle = this.$t('LNG_EDIT_TEACHER', this.lang)
      this.selectedTeacher = data.row.id
      this.name = data.row.name
      this.firstname = data.row.firstname
      this.email = data.row.email
      this.selectCenterGroup.value = data.row.centerId
      this.showTeacherUpdateError = false
      this.teacherEditionModal = true
    },
    exitFileModalTeacher: function () {
      this.displayTeacherImportWarning = false
      this.displayTeacherImportAlert = false
      this.displayTeacherImportSuccess = false
      this.fileModalTeachers = !this.fileModalTeachers
    },
    importTeacher: function () {
      this.displayTeacherImportWarning = false
      this.displayTeacherImportAlert = false
      this.displayTeacherImportSuccess = false
      const input = this.$refs.fileuploadteacher
      input.type = 'text'
      input.type = 'file'
      this.fileModalTeachers = !this.fileModalTeachers
    },
    sendFileTeachers: function (event) {
      event.preventDefault()
      this.displayTeacherImportWarning = false
      this.displayTeacherImportAlert = false
      this.displayTeacherImportSuccess = false
      this.errorMessage = ''
      this.$root.$emit('spinner::show')
      this.formData = new FormData()
      this.formData.append('method', 'uploadFile')
      this.formData.append('import_file', this.teachersFile, this.teachersFile.name)
      this.axios({
        method: 'post',
        url: this.api + '?method=uploadFileTeachers&teacherFileHasHeader=' + this.teacherFileHasHeader,
        data: this.formData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response) => {
        this.$root.$emit('spinner::hide')
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            this.importedTeachers = response.data.numberOfImported
            if (response.data.errors.length > 0 || response.data.errorsCenter.length > 0 || response.data.missingEmail.length > 0 || response.data.centerEmpty > 0) { // ALERT
              this.displayTeacherImportWarning = false
              this.displayTeacherImportAlert = true
              this.displayTeacherImportSuccess = false

              if (response.data.errors.length > 0) {
                this.errorMessage += this.$t('LNG_ERRORS_DOTS', this.lang)
                response.data.errors.forEach((e) => {
                  this.errorMessage += e + ' '
                })
                this.errorMessage += '\r\n'
              }
              if (response.data.errorsCenter.length > 0) {
                this.errorMessage += this.$t('LNG_ERRORS_CENTER_DOTS', this.lang)
                response.data.errorsCenter.forEach((e) => {
                  this.errorMessage += e + ' '
                })
                this.errorMessage += '\r\n'
              }
              if (response.data.missingEmail.length > 0) {
                this.errorMessage += this.$t('LNG_ERRORS_MISSING_EMAILS_DOTS', this.lang)
                response.data.missingEmail.forEach((e) => {
                  this.errorMessage += e + ' '
                })
                this.errorMessage += '\r\n'
              }
              if (response.data.existingEmails.length > 0) {
                this.errorMessage += this.$t('LNG_ERRORS_EXISTING_EMAILS_DOTS', this.lang)
                response.data.existingEmails.forEach((e) => {
                  this.errorMessage += e + ' '
                })
                this.errorMessage += '\r\n'
              }
              if (response.data.centerEmpty > 0) {
                if (response.data.centerEmpty > 1) {
                  this.errorMessage += this.$t('LNG_ERRORS_CENTERS_EMPTY', this.lang, {centerEmpty: response.data.centerEmpty})
                } else {
                  this.errorMessage += this.$t('LNG_ERRORS_CENTER_EMPTY', this.lang)
                }
                this.errorMessage += '\r\n'
              }
            } else if (response.data.existingEmails.length > 0) { // WARNING
              this.displayTeacherImportWarning = true
              this.displayTeacherImportAlert = false
              this.displayTeacherImportSuccess = false

              this.errorMessage += this.$t('LNG_ERRORS_EXISTING_EMAILS_DOTS', this.lang)
              response.data.existingEmails.forEach((e) => {
                this.errorMessage += e + ' '
              })
              this.errorMessage += '\r\n'
            } else {
              this.displayTeacherImportWarning = false
              this.displayTeacherImportAlert = false
              this.displayTeacherImportSuccess = true
              this.errorMessage = response.data.numberOfImported
            }
            this.errorMessage += this.$t('LNG_TEACHER_IMPORT_SUCCESSMESSAGE_DETAILS', this.lang, {importedTeachers: response.data.numberOfImported})
          } else {
            this.displayTeacherImportWarning = false
            this.displayTeacherImportAlert = true
            this.displayTeacherImportSuccess = false
            this.errorMessage = this.$t('LNG_FILE_NOT_UPLOADED', this.lang)
          }
          this.loadTeachers()
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
</style>



// WEBPACK FOOTER //
// managementTeacher.vue?36ed72ac